var _desc, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlyerTakenLightIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    id: "Flyer-Taken--Streamline-Ultimate.svg",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Flyer Taken Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.333333333333332 9.666666666666666a1.3333333333333333 1.3333333333333333 0 0 1 2.6666666666666665 0 1.3333333333333333 1.3333333333333333 0 0 1 2.6666666666666665 0 1.3253333333333333 1.3253333333333333 0 0 1 2 -1.1486666666666667V1.6666666666666665a0.6666666666666666 0.6666666666666666 0 0 0 -0.6666666666666666 -0.6666666666666666h-14a0.6666666666666666 0.6666666666666666 0 0 0 -0.6666666666666666 0.6666666666666666v8",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m2.333333333333333 2.333333333333333 3.333333333333333 0 0 4 -3.333333333333333 0Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m7.666666666666666 3 6 0",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m7.666666666666666 4.333333333333333 6 0",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m7.666666666666666 5.666666666666666 2.6666666666666665 0",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6666666666666665 8.333333333333332a1.3333333333333333 1.3333333333333333 0 0 0 -1.3333333333333333 1.3333333333333333V14.666666666666666a0.3333333333333333 0.3333333333333333 0 0 0 0.3333333333333333 0.3333333333333333h2.333333333333333v-5.333333333333333a1.3333333333333333 1.3333333333333333 0 0 0 -1.3333333333333333 -1.3333333333333333Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.333333333333333 8.333333333333332a1.3333333333333333 1.3333333333333333 0 0 0 -1.3333333333333333 1.3333333333333333v5.333333333333333h2.6666666666666665v-5.333333333333333a1.3333333333333333 1.3333333333333333 0 0 0 -1.3333333333333333 -1.3333333333333333Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.333333333333332a1.3333333333333333 1.3333333333333333 0 0 0 -1.3333333333333333 1.3333333333333333v5.333333333333333H8a0.3333333333333333 0.3333333333333333 0 0 0 0.3333333333333333 -0.3333333333333333v-5a1.3333333333333333 1.3333333333333333 0 0 0 -1.3333333333333333 -1.3333333333333333Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlyerTakenLightIcon);
export default __webpack_public_path__ + "static/media/flyerTakenLightIcon.2b6f4fe6aa0fa9c7762d9eb470f270e6.svg";
export { ForwardRef as ReactComponent };